import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

if (environment.production) {
  enableProdMode();
}

if (environment.appConfig?.enableDatadogRum && environment.appConfig?.datadog?.applicationId) {
  try {
    datadogLogs.init({
      clientToken: environment.appConfig.datadog.clientToken,
      site: environment.appConfig.datadog.site,
      forwardErrorsToLogs: environment.appConfig.datadog.forwardErrorsToLogs,
    });

    datadogRum.init({
      applicationId: environment.appConfig.datadog.applicationId,
      clientToken: environment.appConfig.datadog.clientToken,
      site: environment.appConfig.datadog.site,
      service: environment.appConfig.datadog.service,
      env: environment.appConfig.datadog.env,
      version: environment.appConfig.datadog.version,
      sessionSampleRate: environment.appConfig.datadog.sessionSampleRate,
      sessionReplaySampleRate: environment.appConfig.datadog.sessionReplaySampleRate,
      trackBfcacheViews: environment.appConfig.datadog.trackBfcacheViews,
      defaultPrivacyLevel: environment.appConfig.datadog.defaultPrivacyLevel,
      allowedTracingUrls: environment.appConfig.datadog.allowedTracingUrls,
    });
  } catch (error) {
    console.error('Failed to initialize Datadog RUM:', error);
  }
}

platformBrowserDynamic().bootstrapModule(AppModule);
